import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';

/**
 * A wrapper around useQuery that only executes when the user is authenticated
 */
export function useAuthenticatedQuery<T>(
  options: { queryKey: any[]; queryFn: () => Promise<T>; enabled?: boolean }
) {
  const { user } = useAuth();

  return useQuery<T>({
    ...options,
    enabled: !!user && (options.enabled !== false),
    retry: (failureCount, error: any) => {
      // Don't retry on 401 errors
      if (error?.response?.status === 401) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
